import axios from './base'
import { ITwoFA, IUserCredentials } from '@/utils/interfaces'

export const signin = (userPayload: IUserCredentials): Promise<unknown> => axios.post('/v1/user/_signin', userPayload)
export const validateTwoFaToken = (code: ITwoFA): Promise<unknown> => axios.post('/v1/user/2fa/_validate', code)
